import { createServerFn } from "@tanstack/react-start";

export type ConfiguracaoDevPublica = {
  logarAuth: boolean;
  autoDiagnostico: boolean;
};

/** Configuração pública de diagnóstico, relida pelo servidor a cada página. */
export const obterConfiguracaoDev = createServerFn({ method: "GET" }).handler(
  async (): Promise<ConfiguracaoDevPublica> => {
    const { lerConfiguracaoDev } = await import("@/lib/dev-config.server");
    return lerConfiguracaoDev();
  },
);
